require('flexslider');

module.exports = (function() {
    window.slides = [];

    $('.flexslider').each(function() {
        window.slides[$(this).attr('data-slider-name')] = $(this).find('li').clone();
        loadSlider( $(this), $(this).attr('data-slides-to-show'));
    });

	// Not super fix to fix the slide size on initial load - See Fred or Phil
    currentWidth = 0;
    ReloadSlider();
    ReloadSliderOnResize();
})();

function ReloadSlider() {
	if (currentWidth != $(window).width()) {
		// Update current width
		currentWidth = $(window).width();
		var isMob = window.innerWidth <= 500;
        $('.flexslider').each(function() {
            loadSlider($(this), isMob ? 1 : $(this).attr('data-slides-to-show'));
        });
	}
}

function loadSlider(slider, slidesInScreen) {
    var slideList = window.slides[$(slider).attr('data-slider-name')];
    var animation = getAnimation(slider);
    var slideWidth = getSliderSlideWidth(slider, slideList, animation == "fade" ? 1 : slidesInScreen); // One image at a time for fade
    var classes = $(slider).attr('class');
    var ulClasses = $(slider).find('ul').attr('class');
    var parent = $(slider).parent();
    var sliderName = $(slider).attr('data-slider-name');
    var slidesToShow = typeof($(slider).attr('data-slides-to-show')) != 'undefined' ? $(slider).attr('data-slides-to-show') : 2;
    var showArrows =getBoolean('data-show-arrows', slider, true);
    var showDots = getBoolean('data-show-dots', slider, true);
    var autoplay = getBoolean('data-auto-play', slider, false);
    var html = '<div class="'+classes+'" data-slider-name="'+sliderName+'" data-slides-to-show="'+slidesToShow+'" data-auto-play="'+autoplay+'" data-show-dots="'+showDots+'" data-show-arrows="'+showArrows+'" data-animation="'+animation+'" >';
    html += '<ul class="'+ulClasses+'"></ul></div>';

    $(slider).remove();

    if (slideList.length > 0) {
        $(parent).append(html);
        $(parent).find('.slides').empty().append(slideList);
        $(parent).find('.flexslider').flexslider({
            animation: animation,
            animationLoop: true,
            directionNav: showArrows,
            itemWidth: slideWidth,
            slideshow:autoplay,
            after: function(slider){
                var slide = slider.slides[slider.currentSlide];
                if (typeof($(slide).attr('data-background-image')) !== 'undefined') {
                    var bgImage =$(slide).attr('data-background-image');
                    slider.parents('.content-block').css('background-image', 'url('+bgImage+')');
                }
            },
            controlNav: showDots,
            move:1,
            startAt: 0
        });
    }
}

function getBoolean(attrName, element, defaultVal) {
    var result = false;
    var value = typeof($(element).attr(attrName)) !== 'undefined' ? $(element).attr(attrName) : defaultVal;
    result = value === "true" || value === "1" || value === true || value === 1 ? true : false;
    return result;
}

function getAnimation(element) {
    var result = '';
    var animation = typeof($(element).attr('data-animation')) != 'undefined' ? $(element).attr('data-animation') : '';
    result = animation == 'slide' || animation == 'fade' ? animation : 'slide';
    return result;
}

function getSliderSlideWidth(slider,slideList, slidesInScreen) {
    var isMob = window.innerWidth <= 768;
    var itemWidth =  $(slider).innerWidth();
    var slideWidth = itemWidth;
    var slideCount = $(slideList).length;

    if (isMob) slideWidth =itemWidth;
    else slideWidth = slideCount >=slidesInScreen ? slideWidth / slidesInScreen : slideWidth / slideCount;

    slideWidth = slideWidth < 185 ? itemWidth / 2 : slideWidth;
    return slideWidth;
}


function ReloadSliderOnResize() {
    $(window).resize(function() {
    	// Only resize when the width is different from it's original state
    	ReloadSlider();
    });
}

function loadSlides(SliderObjs){
	var ListEle = jQuery('<li></li>');
	var value = $('#content').html();
	var regEx = /^([^ ]+ ){140}/; /* 140 words */
	var LoopLen = Math.floor(value.match(/\S+/g).length / 140);
	
	for (i=0; i<=LoopLen; i++){
		var NewListEle = ListEle.clone();
		if (new RegExp(regEx).test(value)){
			/* Match the first x words */
			value = value.match(regEx);
			
			/* Array containin the text of the slides */
			$('#banane').append(NewListEle.html(value[0]));
			
			/* Replace the fist X words from the original string */
			value = value.input.replace(regEx, '');
		}else {
			/*Insert the last slide content*/
			$('#banane').append(NewListEle.html(value));
		}
	}
}